import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import TextareaAutosize from 'react-autosize-textarea';
import { emojify } from 'react-emojione';

import Button from 'components/Button';

import * as actions from 'actions';
import { getJournalCreation } from 'selectors';

import './style.scss';

class JournalEntryForm extends Component {
  constructor() {
    super();

    this.handleEmotionChange = this.handleEmotionChange.bind(this);
    this.handleReasonChange = this.handleReasonChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  handleReasonChange(event) {
    this.props.onReasonChange(event.target.value);
  }

  handleFormSubmit(event) {
    event.preventDefault();
    const { selectedEmoji, reason } = this.props;
    if(selectedEmoji && reason) {
      this.props.onEntryCreate(selectedEmoji, reason);
    }
  }

  handleEmotionChange(emoji) {
    this.props.onEmotionChange(emoji);
  }

  render() {
    return (
      <div className="JournalEntryForm">
        <h3>{this.props.title}</h3>
        <p>{this.props.text}</p>
        <form onSubmit={this.handleFormSubmit}>
          <div className="mood-list">
            {this.props.emojis.map((emoji, i) => {
              const className = classnames('mood', {
                active: this.props.selectedEmoji === emoji
              });

              return (
                <div
                  className={className}
                  role="button"
                  key={i}
                  onClick={() => this.handleEmotionChange(emoji)}
                >
                  <span>{emojify(emoji, {output: 'unicode'})}</span>
                </div>
              );
            })}
          </div>
          <div className="form-field-wrapper">
            {this.props.shouldRenderOnOneLine
              ? (
                <input
                  type="text"
                  value={this.props.reason}
                  placeholder={__('members.journal.entryForm.reasonPlaceholder')}
                  onChange={this.handleReasonChange}
                />
              )
              : (
                <TextareaAutosize
                  value={this.props.reason}
                  placeholder={__('members.journal.entryForm.reasonPlaceholder')}
                  onChange={this.handleReasonChange}
                />
              )
            }
          </div>
          <Button
            isYellow
            iconType="preloader-dark"
            hasIcon={this.props.isSubmitting}
            onClick={this.handleFormSubmit}
            isDisabled={!this.props.reason || !this.props.selectedEmoji || this.props.isSubmitting}
          >
            {__('members.journal.entryForm.button')}
          </Button>
        </form>
      </div>
    );
  }
}

JournalEntryForm.propTypes = {
  shouldRenderOnOneLine: PropTypes.bool,
  title: PropTypes.string,
  text: PropTypes.string,
  emojis: PropTypes.arrayOf(React.PropTypes.string),
  reason: PropTypes.string,
  selectedEmoji: PropTypes.string,
  isSubmitting: PropTypes.bool,
  onReasonChange: PropTypes.func,
  onEmotionChange: PropTypes.func,
  onEntryCreate: PropTypes.func
};

const mapStateToProps = state => {
  const { emoji, text, isSubmitting } = getJournalCreation(state);
  return {
    selectedEmoji: emoji,
    reason: text,
    isSubmitting
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onReasonChange: text => {
      dispatch(actions.journalCreationChange({text}));
    },
    onEmotionChange: emoji => {
      dispatch(actions.journalCreationChange({emoji}));
    },
    onEntryCreate: (emoji, text) => {
      dispatch(actions.journalEntryCreate(emoji, text, __('members.journal.successMessage')));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JournalEntryForm);




/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/containers/JournalEntryForm/index.js
 **/